<template>
  <div class="flex h-full">
    <h4 class="mr-8 flex items-center justify-center uppercase font-semibold">
      Configuraciones
    </h4>
    <router-link
      v-for="(menu, k) in options"
      v-bind:key="k"
      tag="span"
      :to="menu.path"
      class="
        cursor-pointer
        h-full
        p-2
        mx-2
        flex
        items-center
        justify-center
        -mb-2
      "
      exact-active-class="active"
      @click.native="$emit('clicked')"
    >
      <i :class="`el-icon-fa-${menu.icon} mr-2`"></i>
      {{ menu.name }}
    </router-link>
  </div>
</template>

<script>
import { checkPermissions } from "../../utils";

export default {
  name: "SettingsSubMenu",
  data() {
    return {
      settingsMenu: [
        {
          icon: "id-badge",
          path: "/settings/organization",
          name: "Estructura",
          submodule: "Organizacion",
        },
        {
          icon: "id-badge",
          path: "/settings/job-positions",
          name: "Puestos de trabajo",
          submodule: "Puestos",
        },
        {
          icon: "file-o",
          path: "/settings/contracts",
          name: "Nóminas y contratos",
          submodule: "Contratos",
        },
        {
          icon: "copy",
          path: "/settings/documents",
          name: "Documentos",
          submodule: "Documentos",
        },
        {
          icon: "calculator",
          path: "/settings/discounts",
          name: "Descuentos de ley",
          submodule: "Descuentos",
        },
        {
          icon: "building-o",
          path: "/settings/banks",
          name: "Bancos",
          submodule: "Bancos",
        },
        {
          icon: "university",
          path: "/settings/universities",
          name: "Instituciones y estudios",
          submodule: "Instituciones",
        },
        {
          icon: "bolt",
          path: "/settings/actions",
          name: "Acciones de P.",
          submodule: "Acciones",
        },
      ],
    };
  },
  computed: {
    options() {
      return this.settingsMenu.filter(
        (item) =>
          this.$store.getters.isSuper ||
          checkPermissions(`Configuraciones:${item.submodule}`, "Page:view") ||
          checkPermissions(`Configuraciones:${item.submodule}`, "Page:viewOwn")
      );
    },
  },
};
</script>
